var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, ThemeProvider } from 'styled-components';
import { defaultTheme, GlobalStyles } from '@hn-ui/themes';
import { Spinner } from '@hn-ui/loaders';
import { support } from '@hn-front/data-types';
import { BlueLink } from '@hn-ui/links';
import { useFetch } from '@hn-front/utils';
import Logo from './parent-logo.svg';
import { ReportDescription } from './ReportDescription';
import { UsingDescription } from './UsingDescription';
import { Table } from './Table';
import { ParentReportEvents, useParentReportAnalytics, } from './hooks/useParentReportAnalytics';
import { useEffect } from 'react';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1xvjmap" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  padding-top: 24px;\n  gap: 32px;\n"], ["\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  padding-top: 24px;\n  gap: 32px;\n"])));
var ScLogo = styled(Logo).withConfig({ displayName: "ScLogo", componentId: "sc-7z3m3i" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 400px;\n  height: 100%;\n"], ["\n  width: 400px;\n  height: 100%;\n"])));
var ErrorDescription = styled.p.withConfig({ displayName: "ErrorDescription", componentId: "sc-1l8w628" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: center;\n"], ["\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: center;\n"])));
var initialReports = [
    {
        id: -1,
        name: 'Parent Report',
        language: 'en',
        status: 'pending',
    },
    {
        id: -2,
        name: 'Parent Report',
        language: 'es',
        status: 'pending',
    },
];
var mergeReports = function (initial, response) {
    return initial.map(function (row) {
        var found = response.find(function (r) { return r.language === row.language; });
        if (found) {
            return __assign(__assign({}, row), { id: found.id, status: found.state, date: found.completedAt || '' });
        }
        return row;
    });
};
var Parent = function (_a) {
    var groupId = _a.groupId, rest = __rest(_a, ["groupId"]);
    var sendGaEvent = useParentReportAnalytics();
    var _b = useFetch("/api/teachers/reports/groups/" + groupId + "?report_type=parent_report"), response = _b.response, isLoading = _b.isLoading;
    var rows;
    if (response) {
        rows = mergeReports(initialReports, response);
    }
    var hasError = rows === null || rows === void 0 ? void 0 : rows.some(function (row) { return row.status === 'failed'; });
    var showSpinner = !response || isLoading;
    useEffect(function () {
        sendGaEvent(ParentReportEvents.pageView);
    }, [sendGaEvent]);
    return (_jsxs(ThemeProvider, __assign({ theme: defaultTheme }, { children: [_jsx(GlobalStyles, {}, void 0), _jsxs(Container, __assign({}, rest, { "data-testid": 'parent-report' }, { children: [_jsx(ReportDescription, {}, void 0), _jsx(ScLogo, { "data-testid": 'logo' }, void 0), _jsx(UsingDescription, {}, void 0), showSpinner && _jsx(Spinner, { icon: { size: 48 } }, void 0), !showSpinner && _jsx(Table, { rows: rows, groupId: groupId }, void 0), hasError && (_jsxs(ErrorDescription, { children: ["We encountered an error. Please contact", ' ', _jsx(BlueLink, __assign({ href: "mailto:" + support.email }, { children: support.email }), void 0), ' ', "for assistance."] }, void 0))] }), void 0)] }), void 0));
};
export default Parent;
var templateObject_1, templateObject_2, templateObject_3;
